import { render } from "./PopupAuth.vue?vue&type=template&id=8ab76110&scoped=true"
import script from "./PopupAuth.vue?vue&type=script&lang=js"
export * from "./PopupAuth.vue?vue&type=script&lang=js"

import "./PopupAuth.vue?vue&type=style&index=0&id=8ab76110&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ab76110"]])

export default __exports__